export default __webpack_public_path__ + "static/media/wishlist_btn.26edf71f.svg";